<!-- 
    描述：在线编辑模板
    时间：2021-07-09
    Created by zl
-->
<template>
	<div class="online-template-layout primary-layout">
		<div class="primary-header">
			<div class="left-text font16">
				在线编辑模板维护
				<el-tooltip placement="right"
							effect="light">
					<div slot="content">
						<p>在线编辑模板维护:管理员创建在线编辑模板,填</p>
						<p class="mt10">写相应的模板文件要求;运营人员在审计作业系统</p>
						<p class="mt10">中根据相应要求选择相应的过程记录事项模板。</p>
					</div>
					<svg-icon class="ml5"
							  icon-class="wenhao"></svg-icon>
				</el-tooltip>
			</div>
			<div class="btnGroups">
				<el-input v-model="searchName"
						  size="small"
						  class="w300"
						  placeholder="请输入模板名称">
					<template slot="append">
						<el-button type="primary"
								   size="small"
								   class="btn-blue"
								   @click="searchResult">查询</el-button>
					</template>

				</el-input>
				<el-button type="primary"
						   size="small"
						   class="ml10 btn-blue"
						   v-if="!isDisabled"
						   @click="doClick('add')">新增模板</el-button>
				<el-button type="success"
						   size="small"
						   class="btn-success"
						   :style="{'margin-left': isDisabled ? '10px' : ''}"
						   icon="el-icon-refresh"
						   @click="refreshResult"></el-button>
			</div>
		</div>
		<div class="primary-content w-table-layout w-table-page">
			<div class="w-table-content">
				<vxe-table align="center"
						   auto-resize
						   border
						   :data="tableObj.table"
						   resizable
						   ref="xTable"
						   height="100%"
						   highlight-current-row
						   highlight-hover-row
						   :loading="tableObj.loading"
						   show-overflow="tooltip"
						   show-header-overflow="tooltip">
					<vxe-table-column type="seq"
									  title="序号"
									  width="80"></vxe-table-column>
					<vxe-table-column field="sname"
									  title="模板名称"
									  header-align="center"
									  align="left"></vxe-table-column>
					<vxe-table-column field="status"
									  title="状态"
									  width="120">
						<template #default="{ row }">
							<vxe-switch v-model="row.status"
										open-label="启用"
										:open-value="1"
										close-label="禁用"
										:close-value="0"
										disabled
										:class="{ opacityHide: isDisabled || row.status == 0 }"
										@click.native.prevent="updateTemplate(row, 1)"></vxe-switch>
						</template>
					</vxe-table-column>
					<vxe-table-column field=""
									  title="操作"
									  width="200">
						<template #default="{ row }">
							<el-button type="success"
									   plain
									   round
									   class="table-btn"
									   v-if="!isDisabled"
									   @click="doClick('edit', row)">
								<svg-icon icon-class="form-edit"></svg-icon> 编辑
							</el-button>
							<el-button type="danger"
									   plain
									   round
									   class="table-btn"
									   v-if="!isDisabled"
									   @click="doClick('delete', row)">
								<svg-icon icon-class="form-delete"></svg-icon> 删除
							</el-button>
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>
			<div class="w-table-pager">
				<vxe-pager align="center"
						   :current-page="tableObj.currentPage"
						   :page-size="tableObj.pageSize"
						   :total="tableObj.total"
						   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
						   @page-change="handleCurrentChange"></vxe-pager>
			</div>
		</div>

		<!-- 模板弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.show"
				   width="1000px"
				   :close-on-click-modal="false"
				   center
				   :before-close="dialogClose">
			<el-form ref="templateForm"
					 :model="templateForm"
					 label-width="100px"
					 :rules="templateRule"
					 size="small"
					 v-if="dialogObj.show">
				<el-form-item label="模板名称"
							  prop="sname">
					<el-input v-model="templateForm.sname"
							  maxlength="30"
							  show-word-limit
							  placeholder="请输入模板名称"></el-input>
				</el-form-item>
				<el-form-item label="模板内容"
							  prop="content">
					<editor ref="editor"
							class="ql-editor"
							v-model="templateForm.content"></editor>
				</el-form-item>
				<el-form-item label="模板状态"
							  prop="status">
					<vxe-switch v-model="templateForm.status"
								open-label="启用"
								:open-value="1"
								close-label="禁用"
								:close-value="0"></vxe-switch>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button class="btn"
						   @click="dialogClose">取 消</el-button>
				<el-button type="primary"
						   class="btn btn-blue"
						   :loading="dialogObj.loading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import * as API from '@/api/basicManage/TemplateManagement'
import editor from 'components/editor/quill_editor'
import { mapState } from 'vuex'
export default {
	name: 'ProcessRecord',
	components: { editor },
	props: {},
	data() {
		return {
			searchName: '', //搜索
			// 表格相关属性
			tableObj: {
				table: [],
				loading: false,
				size: 10,
				current: 1,
				total: 0,
			},
			// 弹框相关属性
			dialogObj: {
				show: false,
				type: 'view',
				title: '',
				loading: false,
			},
			templateForm: {
				sname: '',
				content: '',
				status: 1,
			},
			templateRule: {
				sname: [{ required: true, message: '不能为空...' }],
				content: [{ required: true, message: '不能为空...' }],
				status: [{ required: true, message: '不能为空...' }],
			},
		}
	},
	created() {
		// 获取模板列表
		this.getTempalteData()
	},
	methods: {
		// 获取模板列表
		getTempalteData() {
			this.tableObj.loading = true
			API.getPageList({
				sname: this.searchName,
				size: this.tableObj.pageSize,
				current: this.tableObj.currentPage,
			})
				.then((res) => {
					this.tableObj.loading = false
					this.tableObj.table = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 获取模板信息
		getTempalteInfo(data) {
			API.getTemplateInfo({
				id: data.id,
			}).then((res) => {
				this.templateForm = res.data
				this.$refs.editor.content = res.data.content
			})
		},

		// 确认新增
		doSave() {
			this.$refs.templateForm.validate((valid) => {
				if (valid) {
					this.dialogObj.loading = true
					let params = this.$utils.clone(this.templateForm, true)
					API.saveTemplate(params)
						.then((res) => {
							this.$message.success('操作完成！')
							this.dialogObj.loading = false
							this.dialogClose()
							this.getTempalteData()
						})
						.catch(() => {
							this.dialogObj.loading = false
						})
				} else {
					this.$message.error('请完善表单！')
				}
			})
		},

		//新增模板
		async doClick(type, data) {
			switch (type) {
				case 'add':
					this.dialogObj.title = '新增模板'
					this.dialogObj.show = true
					break
				case 'edit':
					this.dialogObj.title = '编辑模板'
					this.dialogObj.show = true
					this.dialogObj.type = type
					this.getTempalteInfo(data)
					break
				case 'delete':
					this.updateTemplate(data, 0)
					break
			}
		},

		// 删除或者更新状态
		async updateTemplate(data, isFlag) {
			if (this.isDisabled) {
				return
			}
			let msg =
				isFlag == 0 ? '该模板' : '此操作将改变模板状态，是否继续？'
			let status = await this.$deleteConfirm(msg, isFlag)
			if (status) {
				let params = {
					id: data.id,
				}
				isFlag == 0
					? (params.isFlag = 0)
					: data.status == 1
					? (params.status = 0)
					: (params.status = 1)
				this.tableObj.loading = true
				API.updateTemplate(params)
					.then((res) => {
						this.$message.success('操作完成！')
						this.tableObj.loading = false
						this.getTempalteData()
					})
					.catch(() => {
						this.tableObj.loading = false
					})
			} else {
				this.$message.info('操作取消！')
			}
		},

		// 搜索事件
		searchResult() {
			this.tableObj.current = 1
			this.getTempalteData()
		},

		// 重置事件
		refreshResult() {
			this.searchName = ''
			this.searchResult()
		},

		// 处理分页
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
			this.tableObj.pageSize = pageSize
			this.getTempalteData()
		},

		// 弹窗BeforeClose
		dialogClose() {
			this.$refs.editor.content = ''
			this.templateForm.id = ''
			this.templateForm.sname = ''
			this.templateForm.content = ''
			this.templateForm.status = 1
			this.dialogObj.type = ''
			this.dialogObj.title = ''
			this.dialogObj.show = false
		},
	},
	computed: {
		...mapState('user', {
			// 运维角色
			isMaintenance: (state) => state.isMaintenance,
		}),
		// 处理禁用
		isDisabled() {
			return this.isMaintenance
		},
	},
	watch: {
		'templateForm.content': {
			handler(val, oldval) {
				let refs = this.$refs.templateForm
				this.$nextTick(() => {
					if (refs) {
						refs.validateField('content')
					}
				})
			},
			deep: true,
		},
	},
}
</script>
<style lang='less' scoped>
.online-template-layout {
	padding: 30px 20px 10px 20px;
	.font16 {
		font-size: 16px;
	}
	.primary-header {
		height: 50px;
		margin-bottom: 15px;
		border-bottom: 1px dashed #eee;
		align-items: flex-start;
	}
	.w300 {
		/deep/ .el-input__inner {
			width: 300px !important;
		}
		.el-button {
			height: 32px !important;
			padding: 9px 20px;
		}
	}
	.btn {
		height: 40px !important;
		padding: 0px 50px !important;
	}
	.vxe-switch.is--disabled {
		opacity: 1;
		/deep/ .vxe-switch--button {
			cursor: pointer !important;
		}
	}
	/deep/ .is--on {
		.vxe-switch--button {
			background-color: #409eff !important;
		}
	}
	.ql-editor {
		padding: 0px !important;
	}
}
</style>
